export default __webpack_public_path__ + "static/media/afternoon.ee3c3093.svg";